import * as React from "react";
import { Text, TextVariant } from "../../../ui";
import { formatStoredMiles } from "../../formatMiles.utils";
import { hasSpecValue } from "../../VehicleSpecs/specValue.utils";

/** The record's mileage as text: techs never set it here. */
export const ReadOnlyMileage: React.FC<{ odometer?: string | null; source?: string | null }> = ({
  odometer,
  source,
}) => (
  <div className="flex flex-col gap-1" data-testid="read-only-mileage">
    <Text variant={TextVariant.CAPTION} className="text-gray-400">
      Mileage
    </Text>
    {hasSpecValue(odometer) ? (
      <Text variant={TextVariant.BODY1} style={{ fontWeight: 600 }}>
        {formatStoredMiles(odometer)}
        {source && <span className="text-gray-400 text-sm font-normal"> · {source}</span>}
      </Text>
    ) : (
      <Text variant={TextVariant.BODY1} className="text-gray-400">
        Not recorded yet
      </Text>
    )}
    <Text variant={TextVariant.CAPTION} className="text-gray-400">
      Set by the pre-job checklist. Wrong? Ask Ops to correct it.
    </Text>
  </div>
);
